import { KudosApiClient } from '@fourthwall/services/dist/KudosApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useGetTopKudosQuery = createQueryHook(KudosApiClient.getTopKudos, {
  queryKey: ['getTopKudos'],
})
